import {createFileRoute} from '@tanstack/react-router';
import {ResumeApplicationView} from 'features/deposit/onboarding/pages/DepositApplicationResumePage';

export const Route = createFileRoute(
  '/_protected/deposit-onboarding/$applicationId/resume',
)({
  component: ResumeApplicationView,
});
